export enum ThemeConst
{
    Light = "light", Dark = "dark"
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/themeconst.ts